import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const emptyIdent = { id_type: "", id_document_value: "", id_issuing_country: "" };

const saIdValid = (n) => {
  if (!/^\d{13}$/.test(n)) return false;
  const yy = +n.slice(0, 2), mm = +n.slice(2, 4), dd = +n.slice(4, 6);
  const dateOk = [1900, 2000].some((c) => {
    const d = new Date(Date.UTC(c + yy, mm - 1, dd));
    return d.getUTCMonth() === mm - 1 && d.getUTCDate() === dd && d <= new Date();
  });
  if (!dateOk || !"012".includes(n[10])) return false;
  const sum = [...n].reverse().reduce((s, ch, i) => {
    let x = +ch;
    if (i % 2 === 1) { x *= 2; if (x > 9) x -= 9; }
    return s + x;
  }, 0);
  return sum % 10 === 0;
};

// Format/checksum check only — not proof that the document is genuine.
export function identError(v) {
  const num = (v.id_document_value || "").replace(/\s+/g, "").toUpperCase();
  if (!v.id_type) return "Select an identification type";
  if (!num) return "Identification number is required";
  if (v.id_type === "sa_id") return saIdValid(num) ? null : "South African ID must be 13 digits with a valid date and checksum";
  if (!/^[A-Z0-9]{6,20}$/.test(num)) return "Passport number must be 6–20 letters or digits";
  if ((v.id_issuing_country || "").trim().length < 2) return "Passport issuing country is required";
  return null;
}

export default function IdentificationFields({ value, onChange, testidPrefix = "register" }) {
  const [focused, setFocused] = useState(false);
  const set = (k) => (e) => onChange({ ...value, [k]: e?.target ? e.target.value : e });
  return (
    <div className="space-y-2 rounded-md border border-border p-3" data-testid={`${testidPrefix}-ident-fields`}>
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground">
        Identification <span className="normal-case tracking-normal">(required for Saint Herb membership)</span>
      </div>
      <Select value={value.id_type} onValueChange={set("id_type")}>
        <SelectTrigger data-testid={`${testidPrefix}-id-type`}><SelectValue placeholder="Identification type" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="sa_id" data-testid={`${testidPrefix}-id-type-sa`}>South African ID</SelectItem>
          <SelectItem value="passport" data-testid={`${testidPrefix}-id-type-passport`}>Passport</SelectItem>
        </SelectContent>
      </Select>
      <Input
        type={focused ? "text" : "password"} autoComplete="off" inputMode={value.id_type === "sa_id" ? "numeric" : "text"}
        value={value.id_document_value} onChange={set("id_document_value")}
        onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
        placeholder={value.id_type === "passport" ? "Passport number" : "13-digit ID number"}
        data-testid={`${testidPrefix}-id-value`}
      />
      {value.id_type === "passport" && (
        <Input value={value.id_issuing_country} onChange={set("id_issuing_country")}
          placeholder="Issuing country" data-testid={`${testidPrefix}-id-country`} />
      )}
      <div className="text-[10px] text-muted-foreground">
        Masked after entry. Only a one-way hash and the last 3 characters are stored. The format check does not confirm the document is genuine.
      </div>
    </div>
  );
}
